<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="mt-5" style="text-align: initial;"><span class="ml-3"><strong
                style="color: rgb(30, 70, 135);">{{ html.titulo }}</strong></span>
            <ul>
                <li v-for="(termino,index) in html.terminos" :key="index"> -{{ termino }}</li>

            </ul>
          <section class="consideraciones">
            <h1>CONSIDERACIONES IMPORTANTES</h1>

            <div class="linea-divisoria"></div>

            <div class="consideraciones-contenido">

              <!-- Columna izquierda -->
              <div class="columna"  v-for="(consideraciones,index) in terminosYCondiciones.consideracionesImportantes" :key="index">
                <p>
                  <strong v-html="consideraciones.consideracionTitulo"  style="margin-right: 4px;"></strong>
                  <span v-html="consideraciones.consideracionDescripcion"></span>
                </p>
              </div>

            </div>
          </section>
        </div>
    </div>
</template>
<script>

export default {
    name: "TerminosYCondiciones",
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        terminosYCondiciones: null,
        html: {},
    }),
    created(){
      this.debug = this.$localStorageService.getDebug();
        this.obtenerTerminosYCondiciones();
    },
    methods: {
        obtenerTerminosYCondiciones() {
            this.terminosYCondiciones = [];
            this.$http.post(this.$api + 'catalogos/terminosYCondiciones/obtenerTerminos').then(respuesta => {
                if(respuesta.data.data){
                    this.terminosYCondiciones = respuesta.data.data;
                }
            })
        },
    }

};
</script>
<style scoped>
/* Contenedor principal */
.consideraciones {
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
  color: #171d55;
  box-sizing: border-box;
}

/* Título */
.consideraciones h1 {
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #172052;
}

/* Línea debajo del título */
.linea-divisoria {
  height: 2px;
  background-color: #20265c;
  margin-top: 22px;
  margin-bottom: 18px;
}

/* Contenedor de las dos columnas */
.consideraciones-contenido {
  display: grid;
}

/* Cada columna */
.columna {
  min-width: 0;
}

/* Párrafos */
.columna p {
  margin: 0 0 8px 0;
  font-size: 9px;
  line-height: 1.08;
  text-align: justify;
  color: #172052;
}

/* Texto en negritas */
.columna strong {
  font-weight: 700;
}

/* Enlaces */
.columna a {
  color: #172052;
  text-decoration: underline;
}

/* Adaptación para pantallas pequeñas */
@media (max-width: 768px) {
  .consideraciones h1 {
    font-size: 22px;
  }

  .consideraciones-contenido {
    grid-template-columns: 1fr;
    row-gap: 10px;
  }

  .columna p {
    font-size: 12px;
    line-height: 1.15;
  }
}
</style>
